import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { requiredWhenPresent } from '../../shared/propTypes';
import { PeriodPropTypes } from '../shared/propTypes';
import { SlAdminAccountPropTypes } from './propTypes';

import Modal from '../../shared/modals/modal.component';

function DeleteModal(props) {
  const {
    entityToRemove,
    removeEntity,
    hideModal,
    rowIndex,
    period,
    isVisible,
  } = props;

  const { name: periodName } = period;

  const deleteAccount = useCallback(() => {
    if (entityToRemove) {
      removeEntity({ ...entityToRemove, periodName }, { rowIndex });
    }
  }, [removeEntity, entityToRemove, periodName, rowIndex]);

  return (
    <Modal
      className="delete-sl-admin-account-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Account"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={deleteAccount}
      isVisible={isVisible}
    >
      {
        entityToRemove
          ? (
            <div>
              Are you sure you want to delete: <br/><br/>
              Period: {entityToRemove.periodName}<br/>
              SL Account: {entityToRemove.slAccount}<br/>
              View: {entityToRemove.slView}<br/>
              Lifecycle Map: {entityToRemove.lifecycleMap}<br/>
            </div>
          )
          : null
      }
    </Modal>
  );
}

DeleteModal.propTypes = {
  period: PeriodPropTypes.isRequired,
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  entityToRemove: requiredWhenPresent(['isVisible'], SlAdminAccountPropTypes),
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
};

export default DeleteModal;
